import dayjs, { Dayjs } from 'dayjs'

import { yearMonthDaySlash } from 'src/libs'

// Recursively format dayjs values to API date strings for submission.
export const formatDates = (value: unknown): unknown => {
  if (value == null) return value
  if (dayjs.isDayjs(value)) return value.format(yearMonthDaySlash)
  if (Array.isArray(value)) return value.map(formatDates)
  if (typeof value === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
      result[key] = formatDates(val)
    }

    return result
  }

  return value
}

// Inverse of formatDates: parse API date strings back to dayjs for editing.
// The pattern is strict enough to avoid matching IDs, codes or free text.
const DATE_PATTERN = /^\d{4}[-/]\d{2}[-/]\d{2}([T ]\d{2}:\d{2})?/

export const parseDates = (value: unknown): unknown => {
  if (value == null) return value
  if (typeof value === 'string') {
    if (!DATE_PATTERN.test(value)) return value
    const parsed = dayjs(value)

    return parsed.isValid() ? parsed : value
  }
  if (dayjs.isDayjs(value)) return value
  if (Array.isArray(value)) return value.map(parseDates)
  if (typeof value === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
      result[key] = parseDates(val)
    }

    return result
  }

  return value
}

// Safe dayjs for form prefill: a missing or unparseable date stays unset
// instead of becoming an invalid dayjs (dayjs(null) is "Invalid Date").
export const toDayjs = (value: unknown): Dayjs | undefined => {
  if (value == null || value === '') return undefined
  const parsed = dayjs(value as dayjs.ConfigType)

  return parsed.isValid() ? parsed : undefined
}
